/**
 * Lightweight in-memory store for the authenticated user's ID and role.
 *
 * Populated once after the BFF /api/auth/validate response is received
 * (in ShopHomePage) and then read by the axios request interceptor to
 * attach the `X-UserId` header to every outgoing API call.
 * The role is read by MainLayoutScreen's logout handler to decide which
 * screen to navigate back to after logout.
 *
 * AUTH_USER_ID_KEY is the secureStorage key used to persist the logged-in
 * user's own BFF userId across page reloads.  It is distinct from
 * CREATED_USER_ID_KEY (which tracks the admin-selected technician's ID) so
 * that a page refresh never overwrites X-UserId with the technician's ID.
 */
export const AUTH_USER_ID_KEY = 'auth_user_id';

let _userId: number | null = null;
let _role: string | null = null;
let _maintShop: string | null = null;

export const userIdStorage = {
  set(id: number): void {
    _userId = id;
  },
  get(): number | null {
    return _userId;
  },
  setRole(role: string): void {
    _role = role;
  },
  getRole(): string | null {
    return _role;
  },
  setMaintShop(maintShop: string): void {
    _maintShop = maintShop;
  },
  getMaintShop(): string | null {
    return _maintShop;
  },
  clear(): void {
    _userId = null;
    _role = null;
    _maintShop = null;
  },
};